import { inject } from 'aurelia-framework';
import { HttpClient, json } from 'aurelia-fetch-client';
import download from 'downloadjs';
import moment from 'moment';

@inject(HttpClient)
export class SalesForecastService {
  constructor(http) {
    this.http = http;
  }

  async filter(loadOptions) {
    const response = await this.http.fetch(`sales-forecast/filter/${loadOptions}`);
    return await response.json();
  }

  async getCurrent() {
    const response = await this.http.fetch('sales-forecast');
    return await response.json();
  }

  async importMonthlyVolume(csv) {
    const formData = new FormData();
    formData.append('csv', csv);
    await this.http.fetch('sales-forecast/import-monthly-volume', {
      method: 'POST',
      body: formData
    });
  }

  async updateVolume(dateId, volume) {
    await this.http.fetch(`sales-forecast/${dateId}`, {
      method: 'POST',
      body: json({ volume })
    });
  }

  async generateExcelReport() {
      const response = await this.http.fetch('sales-forecast/report/excel');
      const blob = await response.blob();
      download(blob, `Sales Forecast - ${moment().format('L')}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
  }

  async create(type) {
    const response = await this.http.fetch('sales-forecast/report/create/excel', { method: 'POST', body: json({ type }) });
    const blob = await response.blob();
    download(blob, `Sales Forecast - ${moment().format('L')}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
  }

  async download(snapshotId) {
    const response = await this.http.fetch(`sales-forecast/report/snapshot/excel`, { method: 'POST', body: json({ snapshotId }) });
    const blob = await response.blob();
    download(blob, `Sales Forecast - ${moment().format('L')}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
  }
}